export default "__VITE_ASSET__6fe331d1__"